import React, { useEffect, useRef, useState } from 'react'
import BasicModalWindow from '../../components/BasicModalWIndow'
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ItemSelectFieldElement from '../../components/Fields/ItemSelectFieldElement';
import SelectTransactionType, { SelectTransactionFromType } from './SelectTransactionType';
import SelectTransactionActions from './SelectTransactionActions';
import Grid from '@mui/material/Grid2';
import WarehouseSelectFieldElement from '../../components/Fields/WarehouseSelectFieldElement';
import SectionSelectFieldElement from '../../components/Fields/SectionSelectFieldElement';
import LocationSelectFieldElement from '../../components/Fields/LocationSelectFieldElement';
import { addNewItem, updateInventoryItemListRefresh, updateItem, useReturnAllItems, useReturnSingleItem } from '../items/itemsSlice';
import UsersSelectFieldElement from '../../components/Fields/UsersSelectFieldElement';
import DateAndTimeField from '../../components/Fields/DateAndTimeField';
import { useDispatch } from 'react-redux';
import { updateGlobalLoaderStatus } from '../notifications/notificationsSlice';
import TransactionsApp, { EmptyTransactionModel, ITransactionModal } from './TransactionsApp';
import { IAxiosDefaultDataObject } from '../../config';
import { addNewTransaction, resetTansactionSavedDetails, updateAllTransactionsOrders, updateTransactionModalStatus, updateTransactionTiggerModal, updateTransactionTriggerTranscationsRefresh, useReturnAllTransactionOrders } from './transactionsSlice';
import { handleRequestError } from '../../services/api';
import { FormControl, Slider, TextField } from '@mui/material';
import ItemsApp from '../items/ItemsApp';
import DynamicSelect, { IDynamicSelectOption } from '../../components/Fields/DynamicSelect';
import { addNewWarehouse, returnSingleWarehouse, useReturnAllWarehouses } from '../warehouses/warehousesSlice';
import { addNewSection, returnSingleSection, useReturnAllSections } from '../sections/sectionsSlice';
import { addNewLocation, returnSingleLocation, useReturnAllLocations } from '../locations/locationsSlice';
import WarehousesApp from '../warehouses/WarehousesApp';
import SectionsApp from '../sections/SectionsApp';
import LocationsApp from '../locations/LocationsApp';
import { addNewUser, returnSingleUser, useReturnAllUsers, useReturnCurrentUser } from '../user/userSlice';
import UsersApp from '../user/UsersApp';
import ProjectsApp from '../projects/ProjectsApp';
import { addNewProject, useReturnAllProjects } from '../projects/projectsSlice';
import BasicDataViewer from '../../components/DataDisplayer/BasicDataViewer';
import GenerateTransactionDestination from './GenerateTransactionDestination';
import SectionBoxContainer from '../../components/SectionBoxContainer';
import TransactionOrdersList from './TransactionOrdersList';
import { updateDisplayerAllItemsSelectedStatus, updateDisplayerSelectedItems } from '../../components/DataDisplayer/dataDisplyerSlice';
import DateAndTime from '../DateAndTime';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import TranscationDetails from './TranscationDetails';
import QuantitySlider from './QuantitySlider';
import DynamicModelSelect from '../../components/Fields/DynamicModelSelect';
import AlertElement from '../../components/AlertElement';
import { Link } from 'react-router-dom';
import CreateTransaction from './CreateTransaction';

interface IProps {
    shown: boolean,
    itemId?: number,
    handleClose: () => void,
    isOrder?: boolean,
    createOrders?: (action: string, type: string, timestamp: string, project_id: number, warehouse_id: number, section_id: number, location_id: number, user_id: number, warehouse_title: string, section_title: string, location_title: string, user_title: string) => void

}

interface IStep {
    label: string,
    content: (index: number) => JSX.Element,
    onlyAdmin?: boolean,
}

export default function NewTransactionModel(props: IProps) {

    const dispatch = useDispatch()
    const { triggerModalOpen, savedDetails, modalOpenStatus } = useSelector((state: RootState) => state.transactions)
    const { itemId } = props

    const shown = modalOpenStatus


    const handleClose = () => {
        dispatch(updateTransactionModalStatus(false))
    }

    const forceOpenModal = () => {
        dispatch(dispatch(updateTransactionModalStatus(true)))
        dispatch(updateTransactionTriggerTranscationsRefresh(false))
    }

    /**
     * Force open transcation
     */
    // useEffect(() => {
    //     forceOpenModal()
    // }, [triggerModalOpen])

    return(
        <BasicModalWindow
            shown={shown}
            title="Create new transaction"
            size="fullscreen"
            showHeader
            handleClose={handleClose}
            actionButtons={[
                {
                    label: "Close",
                    handleClose: true,
                    color: "error"
                }
            ]}
            pageOverlayStyle
        >   
            <CreateTransaction itemId={itemId} />
        </BasicModalWindow>
    )
}

function OldNewTransactionModel(props: IProps) {

    const dispatch = useDispatch()

    const orderContainerRef = useRef<HTMLDivElement | null>(null)

    const { triggerModalOpen, savedDetails, modalOpenStatus } = useSelector((state: RootState) => state.transactions)

    const { isOrder, createOrders } = props

    const shown = modalOpenStatus

    const [activeStep, setActiveStep] = React.useState<number>(0)

    const currentLoggedInUser = useReturnCurrentUser()

    const orders = useReturnAllTransactionOrders()

    const dateAndTime = new DateAndTime()

    const itemsList = useReturnAllItems()
    const projectsList = useReturnAllProjects()
    const warehousesList = useReturnAllWarehouses()
    const sectionsList = useReturnAllSections()
    const locationsList = useReturnAllLocations()
    const usersList = useReturnAllUsers()

    const [itemId, setItemId] = useState<number>(0)
    const [selectedItem, setSelectedItem] = useState<number>(itemId ? itemId : 0)
    const [selectedType, setSelectedType] = useState<string>("")
    const [selectedFromType, setSelectedFromType] = useState<string>("")
    const [selectedAction, setSelectedAction] = useState<string>("")
    const [note, setNote] = useState<string>("")

    const [warehouseId, setWarehouseId] = useState<number>(0)
    const [sectionId, setSectionId] = useState<number>(0)
    const [locationId, setLocationId] = useState<number>(0)
    const [userId, setUserId] = useState<number>(0)

    const [fromWarehouse, setFromWarehouse] = useState<number>(0)
    const [fromSection, setFromSection] = useState<number>(0)
    const [fromLocation, setFromLocation] = useState<number>(0)
    const [fromUser, setFromUser] = useState<number>(0)

    const [timestamp, setTimestamp] = useState<Date | null>(new Date())
    const [projectId, setProjectId] = useState<number | null>(null)

    const currentItem = useReturnSingleItem(selectedItem)

    const transactionsApp = new TransactionsApp()
    const itemsApp = new ItemsApp()
    const warehousesApp = new WarehousesApp()
    const sectionsApp = new SectionsApp()
    const locationsApp = new LocationsApp()
    const usersApp = new UsersApp()
    const projectsApp = new ProjectsApp()

    const warehouse = returnSingleWarehouse(warehouseId, warehousesList)
    const section = returnSingleSection(sectionId, sectionsList)
    const location = returnSingleLocation(locationId, locationsList)
    const user = returnSingleUser(userId, usersList)

    const [quantity, setQuantity] = useState<number>(1)

    const [itemMaxAvailableQnt, setItemMaxAvailableQnt] = useState<number>(0)
    const [loadingItemMaxAvailableQnt, setLoadingItemMaxAvailableQnt] = useState<boolean>(true)

    const bottomRef = useRef<HTMLDivElement | null>(null);

    const scrollToBottom = () => {
        if (bottomRef.current) {
            bottomRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        // const nextStepId = document.getElementById(`new-transaction-step-${activeStep}`)

        // if (nextStepId){
        //     nextStepId.scrollIntoView({ behavior: "smooth", block: "start" });
        // }
    }
    
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    /**
     * Handle update selected type
     */
    const handleSelectedType = (type: string) => {

        setSelectedType(type)
        handleNext()

        // if (type === "with-user"){
        //     handleSelectedAction("taken")
        //     setSelectedType("with-user")
            
        //     if (!currentLoggedInUser.is_superuser){
        //         handleSubmit("with-user")
        //     }
        // }
    } 

    /**
     * Handle update from selected type
     */
    const handleSelectedFromType = (type: string) => {
        setSelectedFromType(type)
        handleNext()
    } 

    /**
     * Handle update selected action
     */
    const handleSelectedAction = (type: string) => {

        setSelectedAction(type)
        handleNext()
    } 

    /**
     * Trigger inventory list refresh
     */
    const triggerInventoryListRefresh = () => dispatch(updateInventoryItemListRefresh(true))

    /**
     * Reset saved details
     */
    const resetSavedDetails = () => dispatch(resetTansactionSavedDetails({}))

    /**
     * Reset 
     */
    const handleReset = () => {
        setActiveStep(0)
        setSelectedItem(0)
        setSelectedType("")
        setSelectedAction("")
        setWarehouseId(0)
        setSectionId(0)
        setLocationId(0)
        setUserId(0)
        setTimestamp(new Date())

        setFromWarehouse(0)
        setFromSection(0)
        setFromLocation(0)
        setFromUser(0)
        setSelectedFromType("")
        resetSavedDetails()
        setQuantity(1)
        
        props.handleClose()
    }

    /**
     * Handle close
     */
    const handleClose = () => {
        handleReset()

        if (isOrder){
            dispatch(updateAllTransactionsOrders([]))
            dispatch(updateDisplayerSelectedItems({ displayerName: "items_displayer", selectedItems: [] }))
            dispatch(updateGlobalLoaderStatus({ status: false }))
        }

        props.handleClose()
    }

    /**
     * Handle value
     */
    const handleDynamicSelectValue = (value: IDynamicSelectOption) => {
        if (value.value){
            return value.value
        }
        return value
    }


    /**
     * Handle submit
     */
    const handleSubmit = (customType?: string) => {
        
        dispatch(updateGlobalLoaderStatus({ status: true }))

        let data: IAxiosDefaultDataObject = {
            item_id: selectedItem,
            user_id: userId,
            action: selectedAction,
            type: customType ? customType : selectedType,
            timestamp: timestamp,
            warehouse_id: warehouseId,
            section_id: sectionId,
            location_id: locationId,
            // project_id: projectId,
            quantity: quantity,
            from_warehouse: fromWarehouse ? fromWarehouse : null,
            from_section: fromSection ? fromSection : null,
            from_location: fromLocation ? fromLocation : null,
            from_user: fromUser ? fromUser : null,
            note: note
        }

        if (projectId){
            data.project_id = projectId
        }

        if (!currentLoggedInUser.is_superuser){
            data.user_id = currentLoggedInUser.id
        }

        if (isOrder){
            /**
             * Create orders
             */

            if (createOrders){
                createOrders(data.action, data.type, data.timestamp, data.project_id, warehouse.id, section.id, location.id, user.id, warehouse.title, section.title, location.title, user.full_name)
            }

            if (orderContainerRef){
                orderContainerRef.current?.scrollTo({ top: 0, behavior: "smooth" })
            }

        }else{
            /**
             * Make transaction
             */
            transactionsApp.createNewInstance(data)
                .then(response => {

                    dispatch(updateGlobalLoaderStatus({ status: false }))
                    dispatch(addNewTransaction(response.data))

                    triggerInventoryListRefresh()

                    handleClose()

                    /**
                     * Update item
                     */
                    if (selectedItem){
                        itemsApp.singleInstanceDetails(selectedItem)
                            .then(response => {
                                dispatch(updateItem(response.data))
                            })
                            .catch(error => handleRequestError(error, dispatch))
                    }
                    

                })
                .catch(error => {
                    dispatch(updateGlobalLoaderStatus({ status: false }))
                    handleRequestError(error, dispatch)
                })
        }
        
    }

    /**
     * Render stepper buttons
     */
    const renderStepperButtons = (index: number, disabledNext: boolean, disablePrev: boolean = false) => {

        let disableBack: boolean = index === 0

        if (itemId && index === 1){
            disableBack = true
        }

        if (disablePrev){
            disableBack = true
        }

        return(
            <Box sx={{ mb: 2 }}>
                <Button
                    variant="contained"
                    onClick={() => index === steps.length - 1 ? handleSubmit() : handleNext()}
                    sx={{ mt: 1, mr: 1 }}
                    disabled={disabledNext}
                >
                    {index === steps.length - 1 ? 'Finish' : 'Continue'}
                </Button>
                <Button
                    disabled={disableBack}
                    onClick={handleBack}
                    sx={{ mt: 1, mr: 1 }}
                >
                    Back
                </Button>
            </Box>
        )
    }

    /**
     * Item Step
     */
    const itemStep = (index: number) => {
        // return(
        //     <div>
        //         <ItemSelectFieldElement 
        //             id="select-item"
        //             type="SelectItem"
        //             xs={12}
        //             handleOnChange={(id: string, value: any) => {
        //                 setSelectedItem(value)
        //                 handleNext()
        //             }}
        //             data={{ name: "select-item", value: selectedItem }}
        //             fullWidth
        //         />
        //         {renderStepperButtons(index, selectedItem ? false : true)}
        //     </div>
        // )

        const items: () => IAxiosDefaultDataObject[] = () => itemsList
        
        return(
            <div>
                {/* <DynamicSelect 
                    id="select-item"
                    type="SelectItem"
                    xs={12}
                    handleOnChange={(id: string, value: any) => {

                        // @ts-ignore
                        setSelectedItem(handleDynamicSelectValue((value as IDynamicSelectOption)))
                        handleNext()
                    }}
                    data={{ name: "select-item", value: selectedItem }}
                    fullWidth
                    itemsList={items}
                    appClass={itemsApp}
                    // @ts-ignore
                    addNewItem={addNewItem}
                /> */}
                <DynamicModelSelect 
                    id="select-item"
                    type="DynamicModelSelect"
                    label="Item"
                    fullWidth
                    appClass={itemsApp}
                    selectLabel="Select Item"
                    gridColumns={itemsApp.gridDataColumns}
                    xs={12}
                    handleOnChange={(id: string, value: any) => {

                        // @ts-ignore
                        setSelectedItem(handleDynamicSelectValue((value as IDynamicSelectOption)))
                        // handleNext()
                    }}
                    data={{ name: "select-item", value: selectedItem }}
                />
                {renderStepperButtons(index, selectedItem ? false : true)}
            </div>
        )
    }

    /**
     * Type step
     */
    const typeStep = (index: number) => {
        return(
            <div>
                <SelectTransactionType selectedType={selectedType} selectedAction={selectedAction} handleSelectedType={handleSelectedType} />
                {renderStepperButtons(index, selectedType ? false : true)}
            </div>
        )
    }

    /**
     * Type step
     */
    const fromTypeStep = (index: number) => {
        return(
            <div>
                <SelectTransactionFromType selectedType={selectedFromType} selectedAction={"transferred"} isOrigin={true} handleSelectedType={handleSelectedFromType} />
                {renderStepperButtons(index, selectedFromType ? false : true)}
            </div>
        )
    }

    /**
     * Action step
     */
    const actionStep = (index: number) => {
        return(
            <div>
                <SelectTransactionActions selectedType={selectedAction} handleSelectedType={handleSelectedAction} />
                {renderStepperButtons(index, selectedAction ? false : true, isOrder)}
            </div>
        )
    }

    /**
     * Request item available qnt
     */
    const requestItemAvailableQnt = () => {

        setLoadingItemMaxAvailableQnt(true)

        itemsApp.itemAvailableQuantity(selectedItem, fromWarehouse, fromSection, fromLocation, fromUser)
            .then(response => {
                
                const { data } = response
                const availableQuantity = data.available_quantity ? data.available_quantity : 0

                setItemMaxAvailableQnt(availableQuantity)

                setLoadingItemMaxAvailableQnt(false)
            })
            .catch(error => {
                setLoadingItemMaxAvailableQnt(false)
                handleRequestError(error, dispatch)
            })
    }

    /**
     * Qantity step
     */
    const quantityStep = (index: number) => {

        // const handleChange = (event: Event, newValue: number | number[]) => {
        //     if (typeof newValue === 'number') {
        //       setQuantity(newValue);
        //     }
        // }

        // const generateMarks = (max: number) =>
        //     Array.from({ length: max }, (_, i) => ({
        //       value: i + 1,
        //       label: String(i + 1),
        // }))

        return(
            <div>
                {/* <TextField type="number" variant="outlined" fullWidth label="Quantity" value={quantity} onChange={(e) => setQuantity(Number(e.target.value))} inputProps={{ min: 1 }} /> */}
                {/* <div className="quantity-selector-box">
                    <div className="content-of-quantity-selector-box">

                        <h3 className="title-of-quantity-selector-box">Select quantity</h3>

                        <div className="selected-amount-box-of-quantity-selector-box">
                            <div className="content-of-selected-amount-box-of-quantity-selector-box">
                                <p>{quantity}</p>

                                <div className="label-box-of-selected-amount-box-of-quantity-selector-box">
                                    <div className="content-of-label-box-of-selected-amount-box-of-quantity-selector-box">
                                        <span>Selected Quantity</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="slider-qnt-box">
                            <div className="content-of-slider-qnt-box">
                                <Slider
                                    value={quantity}
                                    onChange={handleChange}
                                    aria-labelledby="quantity-slider"
                                    valueLabelDisplay="auto"
                                    step={1}
                                    marks
                                    min={1}
                                    max={itemMaxAvailableQnt}
                                    // @ts-ignore
                                    marks={generateMarks(itemMaxAvailableQnt)} 
                                />
                            </div>
                        </div>

                    </div>
                </div> */}

                <QuantitySlider itemMaxAvailableQnt={itemMaxAvailableQnt} quantity={quantity} updateQuantity={(qnt) => setQuantity(qnt)} />

                {renderStepperButtons(index, selectedType ? false : true)}
            </div>
        )
    }

    /**
     * Move step
     */
    const moveStep = (index: number) => {

        switch(selectedType){

            case "to-warehouse":
                return(
                    <>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 6 }}>
                                <WarehouseSelectFieldElement 
                                    id="select-warehouse"
                                    type="SelectWarehouse"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => setWarehouseId(value)}
                                    data={{ name: "select-warehouse", value: warehouseId }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid size={{ xs: 6 }}>
                                <SectionSelectFieldElement 
                                    id="select-section"
                                    type="SelectSection"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => setSectionId(value)}
                                    data={{ name: "select-section", value: sectionId }}
                                    fullWidth
                                    disabled={warehouseId ? false : true}
                                    searchParams={[
                                        {
                                            name: "warehouse_id",
                                            value: warehouseId
                                        }
                                    ]}
                                />
                            </Grid>
                        </Grid>
                        {renderStepperButtons(index, warehouseId && sectionId ? false : true)}
                    </>
                )

            case "to-section":
                return(
                    <>
                        <SectionSelectFieldElement 
                                    id="select-section"
                                    type="SelectSection"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => {
                                        // @ts-ignore
                                        setSectionId(value)}
                                    }
                                    data={{ name: "select-section", value: sectionId }}
                                    fullWidth
                                    searchParams={[
                                        {
                                            name: "warehouse_id",
                                            value: currentItem.warehouse_id
                                        }
                                    ]}
                        />
                        {renderStepperButtons(index, sectionId ? false : true)}
                    </>
                )

            case "to-location":
                return(
                    <>
                         <LocationSelectFieldElement 
                                    id="select-location"
                                    type="SelectLocation"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => {
                                        // @ts-ignore
                                        setLocationId(value)}
                                    }
                                    data={{ name: "select-location", value: locationId }}
                                    fullWidth
                                   
                        />
                        {renderStepperButtons(index, locationId ? false : true)}
                    </>
                )

                case "with-user":
                    return(
                        <>
                            <p>Hit next</p>
                            {renderStepperButtons(index, false)}
                        </>
                    )

            default:
                return <></>
        }
    }

    /**
     * From step
     */
    const fromStep = (index: number) => {

        switch(selectedFromType){

            case "to-warehouse":
                return(
                    <>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 6 }}>
                                <WarehouseSelectFieldElement 
                                    id="select-from-warehouse"
                                    type="SelectWarehouse"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => setFromWarehouse(value)}
                                    data={{ name: "select-from-warehouse", value: fromWarehouse }}
                                    fullWidth
                                />
                                 {/* <DynamicSelect 
                                        id="select-warehouse"
                                        type="DynamicSelect"
                                        xs={12}
                                        handleOnChange={(id: string, value: any) => {
                                            // @ts-ignore
                                            setWarehouseId(handleDynamicSelectValue(value))}
                                        }
                                        data={{ name: "select-warehouse", value: warehouseId }}
                                        fullWidth
                                        itemsList={warehousesListFunc}
                                        appClass={warehousesApp}
                                        // @ts-ignore
                                        addNewItem={addNewWarehouse}
                                    /> */}
                            </Grid>
                            <Grid size={{ xs: 6 }}>
                                <SectionSelectFieldElement 
                                    id="select-from-section"
                                    type="SelectSection"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => setFromSection(value)}
                                    data={{ name: "select-from-section", value: fromSection }}
                                    fullWidth
                                    disabled={fromWarehouse ? false : true}
                                    searchParams={[
                                        {
                                            name: "warehouse_id",
                                            value: fromWarehouse
                                        }
                                    ]}
                                />
                                 {/* <DynamicSelect 
                                    id="select-section"
                                    type="SelectSection"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => {
                                        // @ts-ignore
                                        setSectionId(handleDynamicSelectValue(value))}
                                    }
                                    data={{ name: "select-section", value: sectionId }}
                                    fullWidth
                                    disabled={warehouseId ? false : true}
                                    searchParams={[
                                        {
                                            name: "warehouse_id",
                                            value: warehouseId
                                        }
                                    ]}
                                 
                                    itemsList={sectionsListFunc}
                                    appClass={sectionsApp}
                                    // @ts-ignore
                                    addNewItem={addNewSection}
                                /> */}
                            </Grid>
                        </Grid>
                        {renderStepperButtons(index, fromWarehouse && fromSection ? false : true)}
                    </>
                )

            case "to-section":
                return(
                    <>
                        {/* <DynamicSelect 
                                    id="select-section"
                                    type="SelectSection"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => {
                                        // @ts-ignore
                                        setSectionId(value)}
                                    }
                                    data={{ name: "select-section", value: sectionId }}
                                    fullWidth
                                    searchParams={[
                                        {
                                            name: "warehouse_id",
                                            value: currentItem.warehouse_id
                                        }
                                    ]}
                                     itemsList={sectionsListFunc}
                                     appClass={sectionsApp}
                                     // @ts-ignore
                                     addNewItem={addNewSection}
                        /> */}
                        <SectionSelectFieldElement 
                                    id="select-from-section"
                                    type="SelectSection"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => {
                                        // @ts-ignore
                                        setFromSection(value)}
                                    }
                                    data={{ name: "select-from-section", value: fromSection }}
                                    fullWidth
                                    // searchParams={[
                                    //     {
                                    //         name: "warehouse_id",
                                    //         value: currentItem.warehouse_id
                                    //     }
                                    // ]}
                        />
                        {renderStepperButtons(index, fromSection ? false : true)}
                    </>
                )

            case "to-location":
                return(
                    <>
                        {/* <DynamicSelect 
                                    id="select-location"
                                    type="DynamicSelect"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => {
                                        // @ts-ignore
                                        setLocationId(handleDynamicSelectValue(value))}
                                    }
                                    data={{ name: "select-location", value: locationId }}
                                    fullWidth
                                     itemsList={locationsListFunc}
                                     appClass={locationsApp}
                                     // @ts-ignore
                                     addNewItem={addNewLocation}
                        /> */}
                         <LocationSelectFieldElement 
                                    id="select-from-location"
                                    type="SelectLocation"
                                    xs={12}
                                    handleOnChange={(id: string, value: any) => {
                                        // @ts-ignore
                                        setFromLocation(value)}
                                    }
                                    data={{ name: "select-from-location", value: fromLocation }}
                                    fullWidth
                                   
                        />
                        {renderStepperButtons(index, fromLocation ? false : true)}
                    </>
                )

            case "with-user":
                return(
                    <>
                        <FormControl fullWidth>
                            <UsersSelectFieldElement 
                                id="select-from-user"
                                type="SelectUser"
                                label="From User"
                                xs={12}
                                handleOnChange={(id: string, value: any) => setFromUser(value)}
                                data={{ name: "select-from-user", value: fromUser }}
                                fullWidth
                            />
                        </FormControl>
                        {renderStepperButtons(index, fromUser ? false : true)}
                    </>
                )

            default:
                return <></>
        }
    }

    /**
     * Final Step
     */
    const finalStep = (index: number) => {
        return(
            <>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 4 }}>
                        <FormControl fullWidth>
                            <UsersSelectFieldElement 
                                id="select-user"
                                type="SelectUser"
                                label="User"
                                xs={12}
                                handleOnChange={(id: string, value: any) => setUserId(value)}
                                data={{ name: "select-user", value: userId }}
                                fullWidth
                            />
                             {/* <DynamicSelect 
                                id="select-user"
                                type="DynamicSelect"
                                label="User"
                                xs={12}
                                handleOnChange={(id: string, value: any) => {
                                    // @ts-ignore
                                    setWarehouseId(handleDynamicSelectValue(value))}
                                }
                                data={{ name: "select-user", value: userId }}
                                fullWidth
                                appClass={usersApp}
                                // @ts-ignore
                                addNewItem={addNewUser}
                            /> */}
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                        <FormControl fullWidth>
                             <DynamicSelect 
                                id="select-project"
                                type="DynamicSelect"
                                label="Project"
                                xs={12}
                                handleOnChange={(id: string, value: any) => {
                                    // @ts-ignore
                                    setProjectId(handleDynamicSelectValue(value))}
                                }
                                data={{ name: "select-project", value: userId }}
                                fullWidth
                                appClass={projectsApp}
                                // @ts-ignore
                                addNewItem={addNewProject}
                                itemsList={() => projectsList}
                                addNoneItem={true}
                            />
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                        <DateAndTimeField 
                            id="timestamp"
                            label="Timestamp"
                            type="DateAndTime"
                            xs={12}
                            handleOnChange={(id: string, value: any) => setTimestamp(value)}
                            data={{ name: "timestamp", value: timestamp }}
                            fullWidth
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <TextField variant="outlined" value={note} multiline minRows={5} maxRows={10} onChange={(e) => setNote(e.target.value)} fullWidth label="Note" />
                    </Grid>
                </Grid>
                {renderStepperButtons(index, userId && timestamp ? false : true)}
            </>
        )
    }

    /**
     * Return confirmStep
     */
    const confirmStep = (index: number, hideButtons: boolean = false) => {

        const transcationObject: ITransactionModal = {
            ...EmptyTransactionModel,
            item_id: itemId,
            user_id: userId,
            action: selectedAction,
            type: selectedType,
            timestamp: timestamp ? new Date(timestamp).toString() : "",
            warehouse_id: warehouseId,
            section_id: sectionId,
            location_id: locationId,
            warehouse_title: warehouse.title,
            section_title: section.title,
            location_title: location.title,
            user_full_name: user.full_name,
            note: note,
            project_id: projectId ? projectId : 0,
            original_warehouse_id: fromWarehouse,
            original_section_id: fromSection,
            original_location_id: fromLocation,
            original_user_id: fromUser,
            quantity: quantity
        }


        return(
            <div className="confirm-step">
                <SectionBoxContainer showTitle={true} title="Details" description="Please, confirm following details of the transaction to proceed">
                    {/* <BasicDataViewer items={[
                        {
                            type: "status",
                            label: "Transaction Action",
                            value: selectedAction,
                        },
                        {
                            type: "status",
                            label: "Transaction Type",
                            value: selectedType
                        },
                        {
                            type: "text",
                            label: "Quantity",
                            value: String(quantity)
                        },
                        {
                            type: "text",
                            label: "Destination",
                            value: "",
                            customContent: () => {
                                return <GenerateTransactionDestination transcation={transcationObject} />
                            }
                        },
                        {
                            type: "text",
                            label: "User",
                            value: user.full_name
                        },
                        {
                            type: "text",
                            label: "Date",
                            value: timestamp ? dateAndTime.formatDateAndTime(timestamp ? new Date(timestamp).toString() : "") : ""
                        },
                    ]} />
                    */}
                    <TranscationDetails {...transcationObject} />
                    {!hideButtons && renderStepperButtons(index, false)}
                </SectionBoxContainer>
            </div>
        )
    }

    const moveStepTitle: string = transactionsApp.returnTypeBasedOnAction(selectedAction, true, selectedType)
    const fromStepTitle: string = transactionsApp.returnFromTypeBasedOnAction(selectedAction, true, selectedType)

    let steps: Array<IStep> = []

    if (!isOrder){
        steps.push({
            label: "Select Item",
            content: itemStep
        })
    }

    steps.push( {
        label: "Transaction Action",
        content: actionStep
    })

    steps.push( {
        label: "Destination Type",
        content: typeStep
    })

    steps.push( {
        label: "Origin Type",
        content: fromTypeStep
    })

    steps.push( {
        label: selectedAction && selectedType ? fromStepTitle : "From",
        content: fromStep
    })

    steps.push({
        label: selectedAction && selectedType ? moveStepTitle : "Destination",
        content: moveStep
    })

    steps.push({
        label: "Quantity",
        content: quantityStep,
    })

    if (currentLoggedInUser.is_superuser){
        steps.push({
            label: "Final Details",
            content: finalStep,
        })
    }

    steps.push({
        label: "Confirm",
        content: confirmStep,
    })

    useEffect(() => {
        if (!isOrder){
            setItemId(props.itemId ? props.itemId : 0)
        }
    }, [props.itemId])

    useEffect(() => {
        
        if (itemId){
            setActiveStep(1)
            setSelectedItem(itemId)
        }

    }, [itemId])

    /**
     * Skip item on isOrder
     */
    // useEffect(() => {
    //     if (isOrder){
    //         setActiveStep(1)
    //     }
    // }, [isOrder])

    /**
     * Trigger modal open
     */
    const handleTriggerModalOpen = (status: boolean) => dispatch(updateTransactionTiggerModal(status))

    /**
     * Handle open modal
     */
    const handleOpenModal = () => dispatch(updateTransactionModalStatus(true))

    /**
     * Trigger modal open
     */
    useEffect(() => {
        if (triggerModalOpen){
            handleTriggerModalOpen(false)
            handleOpenModal()
        }
    }, [triggerModalOpen])

    /**
     * Update saved details
     */
    useEffect(() => {

        if (savedDetails.itemId){
            setSelectedItem(savedDetails.itemId)
            handleNext()
        }

        if (savedDetails.action){
            setSelectedAction(savedDetails.action)
            handleNext()
        }

        if (savedDetails.type){
            setSelectedType(savedDetails.type)
            handleNext()
        }

        if (savedDetails.fromType){
            setSelectedFromType(savedDetails.fromType)
        }

        if (savedDetails.fromWarehouse){
            setFromWarehouse(savedDetails.fromWarehouse)
        }

        if (savedDetails.fromSection){
            setFromSection(savedDetails.fromSection)
        }

        if (savedDetails.fromLocation){
            setFromLocation(savedDetails.fromLocation)
        }

        if (savedDetails.fromUser){
            setFromUser(savedDetails.fromUser)
        }

    }, [shown])

    /**
     * Request ava. qnt
     */
    useEffect(() => {
        requestItemAvailableQnt()
    }, [fromWarehouse, fromSection, fromLocation, fromUser])

    return(
        <BasicModalWindow
            shown={shown}
            title="Create new transaction"
            size="fullscreen"
            showHeader
            handleClose={handleClose}
            actionButtons={[
                {
                    label: "Close",
                    handleClose: true,
                    color: "error"
                }
            ]}
            pageOverlayStyle
        >   
            <AlertElement type="error" message="New transaction module is no longer maintenanced and it's recommended to use the new module called Requests" />
            <div style={{ margin: "15px 0" }}>
                <Link to="/panel/item_requests">Use Requests</Link>
            </div>
            {orders.length === 0 ? (
                <Stepper activeStep={activeStep} orientation="vertical">
                    {steps.map((step, index) => {

                        if (step.onlyAdmin){
                            if (!currentLoggedInUser.is_superuser){
                                return <></>
                            }
                        }

                        return (
                            <Step key={step.label}>
                                <StepLabel
                                    optional={
                                        index === steps.length - 1 ? (
                                        <Typography variant="caption">Last step</Typography>
                                        ) : null
                                    }
                                >
                                    {step.label}
                                </StepLabel>

                                <StepContent>

                                    <div className="transaction-step-content-container" id={`new-transaction-step-${index}`} ref={bottomRef}>
                                        <div className="content-of-transaction-step-content-container">
                                            {step.content(index)}
                                        </div>
                                    </div>
                                    
                                </StepContent>
                            </Step>
                        )
                    })}
                </Stepper>
            ) : (
                <div className="transcations-order-details-in-modal-container" ref={orderContainerRef}>
                    <div className="content-of-transcations-order-details-in-modal-container">
                        {confirmStep(0, true)}
                       
                        <TransactionOrdersList handleResetNewTransactionModal={handleReset} />
                    </div>
                </div>
            )}
        </BasicModalWindow>
    )
}